import React, { useState } from "react";

// CSS in App.css
// stolen from cssportal.com

// Define the props interface for type safety
interface ToggleSwitchProps {
  id?: string;
  name?: string;
  defaultChecked?: boolean;
  onChange?: (checked: boolean) => void;
  label: string;
  disabled?: boolean;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  id = "fs",
  name = "flipswitch",
  defaultChecked = false,
  onChange,
  label,
  disabled
}) => {
  const [isChecked, setIsChecked] = useState(defaultChecked);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newChecked = event.target.checked;
    setIsChecked(newChecked);
    if (onChange) {
      onChange(newChecked);
    }
  };

  return (
    <div className="flipswitch">
      <div className="switch-container">
        <input
          type="checkbox"
          name={name}
          className="flipswitch-cb"
          id={id}
          checked={isChecked}
          onChange={handleChange}
          disabled={disabled}
        />
        <label className="flipswitch-label" htmlFor={id}>
          <div className="flipswitch-inner" />
          <div className="flipswitch-switch" />
        </label>
      </div>
      <span className="label">{label}</span>
    </div>
  );
};

export default ToggleSwitch;
